module.exports = __webpack_public_path__ + "img/skycraper.fdef931a.svg";